import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';

import TableRender, { TableRenderFieldT } from 'shared/components/Table/TableRender';
import { SourcesResultT } from 'shared/models/sources';
import { SourcesIdentifiers } from 'shared/models/sources-form';
import api from 'utils/api';
import { datePrettyDisplay, formatDateFromNow } from 'utils/date';

import './Sources.scss';

function Sources() {
  const history = useHistory();

  const goToSourceID = (id: string) => {
    history.push(`/sources/${id}`);
  };

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Name',
      renderFn: (row: SourcesResultT) => row.name,
    },
    {
      displayName: 'Type',
      renderFn: (row: SourcesResultT) => (
        SourcesIdentifiers[row.source]
          ? SourcesIdentifiers[row.source].displayName
          : row.source
      ),
      align: 'center',
    },
    {
      displayName: 'Created by',
      renderFn: (row: SourcesResultT) => row.createdBy,
      align: 'center',
    },
    {
      displayName: 'Last Update',
      renderFn: (row: SourcesResultT) => formatDateFromNow(row.lastUpdated),
      tooltipFn: (row: SourcesResultT) => datePrettyDisplay(row.lastUpdated),
      align: 'center',
    },
  ];

  return (
    <div>
      <div className="title__header">
        <h1>Sources</h1>
        <Link to="/sources/create">
          <Button variant="contained" color="secondary">Create</Button>
        </Link>
      </div>
      <TableRender
        api={api.sources}
        renderFields={fields}
        onClickRow={(row: any) => goToSourceID(row.id)}
      />
    </div>
  );
}

export default Sources;
